
import { Injectable, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
    SuretyBondModel, BondSearchCriteria, CertificateOfDepositModel, SurplusInsurerModel, RbdmsOwnersModel, WellTransferListingModel,
    ContactHistoryModel, ReportSearchCriteria, ContactHistoryCriteria, LetterOfCreditModel, LogSearchSpec, ApplicationLog,
    BondingReportSearchCriteria
} from "../models/admin-reports.model";
import { BondingReportModel } from "../../common/models/financialAssurance.model";



@Injectable()
export class AdminReportsService implements OnInit {

    constructor(public http: HttpClient) {

    }
    ngOnInit() { }

    getActiveBonds(): Observable<SuretyBondModel[]> {

        return this.http.get<SuretyBondModel[]>(`api/financial-assurance-reports/activebonds`);
    }
    getCertificateOfDeposits(criteria: BondSearchCriteria): Observable<CertificateOfDepositModel[]> {
        const query = this.buildParams(criteria);

        return this.http.get<CertificateOfDepositModel[]>(`api/financial-assurance-reports/certificateofdeposits?${query}`);
    }

    getContactHistoryReport(criteria: ContactHistoryCriteria): Observable<ContactHistoryModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<ContactHistoryModel[]>(`api/reports/contact-history-report?${query}`);
    }

    getSurplusInsurerInfo(criteria: BondSearchCriteria): Observable<SurplusInsurerModel[]> {
        const query = this.buildParams(criteria);

        return this.http.get<SurplusInsurerModel[]>(`api/financial-assurance-reports/getsurplusinsurerinfo?${query}`);
    }

    getRbdmsOwners(): Observable<RbdmsOwnersModel[]> {
        return this.http.get<RbdmsOwnersModel[]>(`api/financial-assurance-reports/getrbdmsownersinfo`);
    }

    getWellTransferInfo(criteria: ReportSearchCriteria): Observable<WellTransferListingModel[]> {
        const query = this.buildParams(criteria);

        return this.http.get<WellTransferListingModel[]>(`api/financial-assurance-reports/getwelltransferinfo?${query}`);
    }

    getFailedWellTransferInfo(criteria: ReportSearchCriteria): Observable<WellTransferListingModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<WellTransferListingModel[]>(`api/financial-assurance-reports/getfailedwelltransferinfo?${query}`);
    }

    getLettersOfCredit(criteria: ReportSearchCriteria): Observable<LetterOfCreditModel[]> {
        const query = this.buildParams(criteria);
        return this.http.get<LetterOfCreditModel[]>(`api/financial-assurance-reports/lettersofcredit?${query}`);
    }

    getBondingReceived(criteria: BondingReportSearchCriteria): Observable<BondingReportModel[]> {
        return this.http.post<BondingReportModel[]>(`api/financial-assurance-reports/bonding-received`, criteria)
    }

    getCollateralReleased(criteria: BondingReportSearchCriteria): Observable<BondingReportModel[]> {
        return this.http.post<BondingReportModel[]>(`api/financial-assurance-reports/collateral-released`, criteria)
    }

    searchApplicationLogs(spec: LogSearchSpec): Observable<ApplicationLog[]> {
        return this.http.post<ApplicationLog[]>("api/reports/application-logs", spec);
    }

    private buildParams(criteria: ReportSearchCriteria): string {
        const params = new URLSearchParams();
        for (let key in criteria) {
            if (criteria.hasOwnProperty(key)) {
                const value = criteria[key];
                if (value instanceof Array) {
                    for (let index in value) {
                        if (value.hasOwnProperty(index)) {
                            params.set(key + "[" + index + "]", value[index]);
                        }
                    }
                } else if (value instanceof Date) {
                    params.set(key, value.toISOString());
                } else if (value != null) {
                    params.set(key, value);
                }
            }
        }
        return params.toString();
    }

}

